module.exports = __webpack_public_path__ + "bb43a588962e3b29bdd355437d014e31.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/ybicons/iconfont.woff?t=1584093387977
// module id = 1224
// module chunks = 3